<script lang="ts">
	import heroImageXs from "@assets/images/fathers-family-hero.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/fathers-family-hero.jpg?webp&h=1300&quality=95&imagetools";
	import heroImageLg from "@assets/images/fathers-family-hero.jpg?webp&h=1600&imagetools";
	import heroImageXl from "@assets/images/fathers-family-hero.jpg?webp&h=1900&imagetools";
	import heroImage2xl from "@assets/images/fathers-family-hero.jpg?webp&h=1920&imagetools";
	import heroImage3xl from "@assets/images/fathers-family-hero.jpg?webp&imagetools";
	import fathersFamilyLogo from "@assets/images/fathers-family-written.png?webp&w=642&&imagetools";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import MembershipAboutSection from "@components/membership/MembershipAboutSection.svelte";
	import MembershipBenefitSection from "@components/membership/MembershipBenefitSection.svelte";
	import FaqSection from "@components/sections/FaqSection.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import LongTermSubscriptionSection from "@components/sections/LongTermSubscriptionSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./MembershipPage.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<Layout transparentHeader>
	<ImageSection
		lcp
		class="min-h-[45rem] xl:!h-[calc(100vh-9rem)] pointer-events-none relative"
		sources={{
			default: heroImageXs,
			">lg": heroImageLg,
			">sm": heroImageSm,
			">xl": heroImageXl,
			">2xl": heroImage2xl,
			">3xl": heroImage3xl,
		}}
		media="object-[45%_35%]"
		darkOverlay={false}
	>
		{#snippet heading()}
			<Heading
				level={1}
				text={translate("heroTitle")}
				class="absolute top-44 left-1/2 -translate-x-1/2 w-[min(90vw,40rem)]"
			>
				<Media
					width={640}
					height={442}
					sourcesets={{}}
					source={{ type: "image/webp", src: fathersFamilyLogo }}
					alt=""
				/>
			</Heading>
		{/snippet}
	</ImageSection>
	<MembershipBenefitSection />
	<MembershipAboutSection />
	<FaqSection />
	<LongTermSubscriptionSection />
</Layout>
